import toast from "react-hot-toast";

export const COMPLIANCE_BLOCKED = "compliance_blocked";

/**
 * Property compliance gates (going live, advertising online, sending a
 * Contract of Sale) answer either with `compliance_warnings` on a successful
 * response (warn mode) or a 400 `code: "compliance_blocked"` (block mode).
 * Shown once, wherever the action came from.
 */
export const showComplianceWarnings = (data) => {
  const warnings = data?.compliance_warnings;
  if (!Array.isArray(warnings) || warnings.length === 0) return false;
  toast(`Compliance: ${warnings.join("; ")}. Check the property's Compliance tab.`, {
    id: "compliance-warnings", icon: "⚠️", duration: 9000,
  });
  return true;
};

export const isComplianceBlocked = (err) => err?.response?.data?.code === COMPLIANCE_BLOCKED;

export const showComplianceBlocked = (err) => {
  if (!isComplianceBlocked(err)) return false;
  toast.error(err.response.data.detail || "Blocked by property compliance.", {
    id: "compliance-blocked", duration: 10000,
  });
  return true;
};
